import { render, staticRenderFns } from "./hostMenu.vue?vue&type=template&id=374b1665&scoped=true&"
import script from "./hostMenu.vue?vue&type=script&lang=js&"
export * from "./hostMenu.vue?vue&type=script&lang=js&"
import style0 from "./hostMenu.vue?vue&type=style&index=0&id=374b1665&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374b1665",
  null
  
)

export default component.exports